<div id="invitation" class="registration container">
    <h1>Decline Acknowledgement</h1>
    <section class="card">
        <div class="card-header">
            <div class="card-title ms-0">
                Response Submitted Successfully 
            </div>
        </div>
        <div class="card-body" [innerHTML]="'copy.html.declineText'|copy|async">
        </div>
    </section>
</div>